
export const collectionitems = [
    {
        name: 'Item 3x1213c',
        price: '0.21 ETH',
        image: 'https://images.unsplash.com/photo-1544967082-d9d25d867d66?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection : 'collection',
    },
    {
        name: 'Item 55xsa213c',
        price: '0.12 ETH',
        image: 'https://images.unsplash.com/photo-1605106250963-ffda6d2a4b32?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection : 'collection',
    },
    {
        name: 'Item 11x1213c',
        price: '0.42 ETH',
        image: 'https://images.unsplash.com/photo-1489648022186-8f49310909a0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=910&q=80',
        collection : 'collection',
    },
    {
        name: 'Item 2bx1w13d',
        price: '0.31 ETH',
        image: 'https://images.unsplash.com/photo-1595598034023-ca08624ce05d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2051&q=80',
        collection : 'collection',
    },
    {
        name: 'Item 55xsa213c',
        price: '0.12 ETH',
        image: 'https://images.unsplash.com/photo-1576616569455-d2a9127ae8c1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection : 'collection',
    },
    {
        name: 'Item 11x1213c',
        price: '0.42 ETH',
        image: 'https://images.unsplash.com/photo-1523441263-830cac2fe90b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection : 'collection',
    },
    {
        name: 'Item 3x1213c',
        price: '0.21 ETH',
        image: 'https://images.unsplash.com/photo-1570361269465-290e1149df5d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=901&q=80',
        collection : 'collection',
    },
    {
        name: 'Item 11x1213c',
        price: '0.42 ETH',
        image: 'https://images.unsplash.com/photo-1579159279288-76bd8f1bf445?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=880&q=80',
        collection : 'collection',
    },
]